import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

import ParameterInput from 'SharedComponents/Fields/FieldParams/ParameterInput.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldParameter } from 'SharedDir/declarations/fields';
import { Json } from 'SharedDir/declarations/shared';

interface Props extends PropValue<Json> {
  set: Array<FieldParameter>;
  readonly?: boolean;
  except?: Array<string>;
  validationErrors?: { [paramName: string]: string };
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ParametersSet', components: { ParameterInput } },
  __name: 'ParametersSet',
  props: {
    set: {},
    readonly: { type: Boolean, default: false },
    except: { default: () => ['default'] },
    validationErrors: { default: () => ({}) },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;

/**
 * Параметр отвечающий за скрытие поля при заполнении
 * Заполняется в JSON поле params
 * В данном случае заполняется только с фронта
 */
const isHiddenParameter: FieldParameter = {
  type: 'boolean',
  isOptional: true,
  extra: null,
  name: 'isHidden',
  label: 'Скрывать поле при заполнении',
  description: 'Скрывать поле при заполнении значений в форме',
  defaultValue: false,
};

const { innerValue, emitValue } = useValue(props, emit);
const filteredSet = computed(() => {
  if (props.except.length === 0) {
    return props.set;
  }
  return props.set.filter(({ name }) => !props.except.includes(name));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSet.value, (param, index) => {
      return (_openBlock(), _createBlock(ParameterInput, {
        key: index,
        modelValue: _unref(innerValue)[param.name],
        "onUpdate:modelValue": [($event: any) => ((_unref(innerValue)[param.name]) = $event), _unref(emitValue)],
        class: "q-mb-sm",
        error: !!_ctx.validationErrors[param.name],
        "error-message": _ctx.validationErrors[param.name],
        parameter: param,
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "error-message", "parameter", "readonly"]))
    }), 128)),
    (_openBlock(), _createBlock(ParameterInput, {
      key: filteredSet.value.length + 1,
      modelValue: _unref(innerValue)[isHiddenParameter.name],
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue)[isHiddenParameter.name]) = $event)),
        _unref(emitValue)
      ],
      class: "q-mb-sm",
      error: !!_ctx.validationErrors[isHiddenParameter.name],
      "error-message": _ctx.validationErrors[isHiddenParameter.name],
      parameter: isHiddenParameter,
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "error", "error-message", "readonly", "onUpdate:modelValue"]))
  ]))
}
}

})